import { Typography } from '@oresundsbron/bridge-ui';

export const VoucherValidUntil = ({
  label,
  date,
  locale,
}: {
  label: string;
  date: string;
  locale: string;
}) => (
  <Typography intent="label" size="lg" color="white">
    {`${label} ${new Date(date).toLocaleDateString(locale, {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })}
  `}
  </Typography>
);
